import { render } from "./Merchant.vue?vue&type=template&id=37d347dd&scoped=true"
import script from "./Merchant.vue?vue&type=script&lang=js"
export * from "./Merchant.vue?vue&type=script&lang=js"

import "./Merchant.vue?vue&type=style&index=0&id=37d347dd&scoped=true&lang=css"
import "./Merchant.vue?vue&type=style&index=1&id=37d347dd&lang=css"

import exportComponent from "C:\\ProgramData\\Jenkins\\.jenkins\\workspace\\sport.yanhuotiyu.com焱火pc端web网站\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37d347dd"]])

export default __exports__